export const validatePhoneNumber = (value: string) => {
  if (value.length === 18) {
    return true;
  }

  return 'Неверный формат номера телефона. Введите, пожалуйста, 11 цифр.';
};
